<template>
  <div class>
    <el-dialog title="选择短信模板" :width="list.length > 4 ? '600px':'574px'" class="repair-dialog" :visible.sync="dialogHide" :before-close="handleClose" center>
      <div class="p10 flex-row wraps bodys">
        <el-card class="box-card" v-for="item in list" :key="item.id">
          <div slot="header" class="clearfix space-between" @click="handBox(item)">
            <span>{{item.name}}</span>
            <span class="box-select" v-if="item.show"><img src="../../../assets/images/new/yuanjian-check.png" alt=""></span>
          </div>
          <div class="text item" @click="handBox(item)">{{item.contentDisplay}}</div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn small-btn" type="primary" @click="save">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      query: {
        start: 1,
        size: 20
      },
      list: [],
      dialogHide: false,
      mainHeight: this.$store.getters.MainHeight,
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    handleClose() {
      this.dialogHide = false;
    },
    init() {
      this.$on("open", function(org) {
        this.dialogHide = true;
        if (org) {
          this.form = JSON.parse(JSON.stringify(org));
        }
        this.getTemplate();
      });
    },
    getTemplate () {
      this.$api.get(this.$url.smsTemplate.smsTemplateList, this.query).then(res => {
        if (res) {
          res.map(item => {
            item.show = false;
            if (this.form.id && this.form.id == item.id) {
              item.show = true;
            }
          })
          this.list = res;
        }
      }).catch(error => {})
    },
    handBox (row) {
      this.list.map(item => {
        item.show = false;
      })
      row.show = true;
      this.form = row;
    },
    save () {
      this.$emit("change", this.form);
      this.dialogHide = false;
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.text {
  padding: 20px;
    font-size: 14px;
  }
  .clearfix {
    padding: 10px;
  }
  .box-card {
    width: 260px;
    margin-right: 10px;
    margin-bottom: 10px;
    &:nth-of-type(2n) {
      margin-right: 0;
    }
  }
  .box-select {
    display: inline-block;
    width: 16px;
    height: 16px;
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
  .bodys {
    height: 430px;
    overflow: auto;
  }

/deep/ .el-dialog {
  // height: 261px;
  border-radius: 10px;
}
/deep/ .el-dialog__header {
  height: 50px;
  box-sizing: border-box;
  padding: 0 16px;
  line-height: 50px;
  text-align: center;
  font-size: 0.18rem;
  .el-dialog__headerbtn {
    top: 13px;
    .el-dialog__close {
      color: #666;
      border: 1px solid #666;
      border-radius: 50%;
      padding: 2px;
      &:hover {
        color: @blue;
        border: 1px solid @blue;
        background: #fff;
      }
    }
  }
}
/deep/ .el-dialog__body {
  padding: 20px 20px 0;
  height: auto !important;
}

/deep/ .el-dialog__footer {
  text-align: center;
  margin-top: 10px;
  .btn {
    font-size: 0.18rem;
    // width: 155px;
    // height: 55px;
  }
  .normal-btn {
    margin-right: 50px;
  }
}
</style>